<template>
  <div class="animated fadeIn">
    <h3>Water Report</h3>
    <b-card v-for="(sample, index) in samples" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          <b>Sample ID</b>: {{ sample.number }} | <b>Usage</b>:
          {{ sample.usage }}
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table
          class="mb-0"
          :items="sample.analyses"
          :fields="columns"
          responsive
          bordered
        >
          <template #cell(range)="data">
            <report-progress-bar
              :result="data.item.result"
              :low="data.item.range.acceptable"
              :high="data.item.range.unacceptable"
            />
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ReportProgressBar from "@/components/shared/ReportProgressBar";

export default {
  name: "SubmissionWaterReport",
  components: { ReportProgressBar },
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        { key: "name", label: "Analysis" },
        { key: "result", label: "Result" },
        { key: "unit", label: "Units" },
        { key: "range", label: "Water Quality Guidelines" },
      ],
    };
  },
};
</script>
